<template>
  <div class="content-430">
    <div class="header-wrapper-430">
      <IndexSearch @on-search="onSearch"></IndexSearch>
      <div
        class="table-title-special-430"
        style="display: flex; justify-content: right"
      >
        <Button type="primary" @click="handleAdd">添加分账规则</Button>
      </div>
    </div>
    <div class="table-wrap">
      <Table
        :columns="columns"
        :loading="loadingData"
        :data="tableList"
        border
        :max-height="tableHeight"
      >
        <template slot="isEnable" slot-scope="{ row, index }">
          <span v-if="row.isEnable == 1" style="color: #19be6b">开启</span>
          <span v-else style="color: #c5c8ce">已关闭</span>
        </template>

        <template slot="providerType" slot-scope="{ row, index }">
          <span
            v-if="row.providerType == 1"
            style="color: #19be6b"
          >入账到课程机构账户</span>
          <span v-else style="color: #409eff">入账到学校账户</span>
        </template>

        <template slot="configName" slot-scope="{ row, index }">
          <TablePoptip :content="row.configName"> </TablePoptip>
        </template>
        <template slot="busiTypes" slot-scope="{ row }">
          <TablePoptip :content="getTypeNames(row)"> </TablePoptip>
        </template>
        <template slot="inAccountType" slot-scope="{ row, index }">
          <span>{{ getAccountNamesFun(row.inAccountType) }}</span>
        </template>
        <template slot="bankName" slot-scope="{ row, index }">
          <span>{{ getBankNamesFun(row, row.inAccountType) }}</span>
        </template>
        <template slot="wxRate" slot-scope="{ row, index }">
          <span>{{ row.wxRate | wxRateShow }}</span>
        </template>
        <template slot="action" slot-scope="{ row, index }">
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToDetail(row)"
          >详情</span>
          <span
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToEdit(row)"
          >编辑</span>
          <span
            v-if="row.providerType != 2"
            class="ordinary-color-430"
            style="margin-right: 8px"
            @click="handleToSetOrg(row)"
          >配置课程提供方</span>
          <span
            class="ordinary-color-430"
            @click="handleToSetSch(row)"
          >配置可见学校</span>
        </template>
      </Table>
    </div>
    <div class="page-wrap">
      <Page
        :current="pageInfo.pageNum"
        :total="pageInfo.total"
        :page-size="pageInfo.pageSize"
        show-total
        show-elevator
        show-sizer
        :page-size-opts="pageSizeOpts"
        @on-change="pageChange"
        @on-page-size-change="handleSizeChange"
      ></Page>
    </div>
    <ProfitShareDetailModal ref="profitShareDetailModal"></ProfitShareDetailModal>
    <ProfitShareDeployOrgModal ref="profitShareDeployOrgModal" @refreshData="getDivideConfigList"></ProfitShareDeployOrgModal>
    <ProfitShareDeploySchModal ref="profitShareDeploySchModal" @refreshData="getDivideConfigList"></ProfitShareDeploySchModal>
  </div>
</template>

<script>
import IndexSearch from './assets/components/IndexSearch.vue';
import { columns } from './assets/data/index';
import orderCenterApi from '@/request/orderCenter/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
import { getBusiTypeNames, getAccountNames } from './assets/data/index';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { dev } from '@/utils/utils';
import ProfitShareDetailModal from './components/ProfitShareDetailModal.vue';
import ProfitShareDeployOrgModal from './components/ProfitShareDeployOrgModal.vue';
import ProfitShareDeploySchModal from './components/ProfitShareDeploySchModal.vue';
export default {
  name: 'OrderCenterProfitSharingIndex',
  components: {
    IndexSearch,
    ProfitShareDetailModal,
    ProfitShareDeployOrgModal,
    ProfitShareDeploySchModal
  },
  filters: {
    wxRateShow(wxRate) {
      return isNaN(+wxRate) ? '' : `${dev(wxRate, 100)}%`;
    }
  },
  mixins: [mixinTableHeight],
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('OrderCenterProfitSharingIndex');
    next();
  },
  data() {
    return {
      columns,

      tableList: [],
      pageSizeOpts: [10, 20, 50, 100],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchConds: {
        configName: '',
        schoolId: ''
      },
      loadingData: false
    };
  },
  created() {
    this.getDivideConfigList();
  },
  beforeDestroy() {
    console.log('beforeDestroy');
  },
  destroyed() {
    console.log('destroyed');
  },
  activated() {
    this.getDivideConfigList();
  },
  methods: {
    ...mapMutations([
      'PUSH_CACHEROUTE'
    ]),
    // 列表数据
    async getDivideConfigList() {
      const parameter = {
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        ...this.searchConds
      };
      this.loadingData = true;
      const res = await orderCenterApi.getDivideConfigList(parameter);
      this.loadingData = false;
      if (res.status == 200) {
        this.tableList = res.message.list;

        this.pageInfo.total = Number(res.message.total);
      }
    },
    onSearch(info) {
      this.pageInfo.pageNum = 1;
      this.searchConds = info;
      this.getDivideConfigList();
    },
    getTypeNames(row) {
      return row.itemType == 2 ? '材料费' : getBusiTypeNames(row.busiTypes);
    },
    // 页码改变
    pageChange(page) {
      this.pageInfo.pageNum = page;
      this.getDivideConfigList();
    },
    handleSizeChange(size) {
      this.pageInfo.pageSize = size;
      this.pageInfo.pageNum = 1;
      this.getDivideConfigList();
    },
    getToQuery(row) {
      return {
        configId: row.configId,
        operatorName: row.operatorName,
        operateTime: row.operatorTime,
        createTime: row.createTime,
        bankId: row.bankId,
        bankName: row.bankName,
        providerType: row.providerType,
        inAccountType: row.inAccountType,
        itemType: row.itemType
      };
    },
    // 查看详情
    handleToDetail(row) {
      this.$refs.profitShareDetailModal.openDrawer(this.getToQuery(row));
      // this.$router.push({
      //   name: 'orderCenter_profitSharing_index_details', query: this.getToQuery(row)
      // });
    },

    handleToEdit(row) {
      this.$router.push({
        name: 'orderCenter_profitSharing_index_edit', query: this.getToQuery(row)
      });
    },
    // 配置机构
    handleToSetOrg(row) {
      this.$refs.profitShareDeployOrgModal.openDrawer(this.getToQuery(row));
      // this.$router.push({
      //   name: 'orderCenter_profitSharing_index_deployOrg', query: this.getToQuery(row)
      // });
    },
    // 配置可见学校
    handleToSetSch(row) {
      this.$refs.profitShareDeploySchModal.openDrawer(this.getToQuery(row));

      // this.$router.push({
      //   name: 'orderCenter_profitSharing_index_deploySch', query: this.getToQuery(row)
      // });
    },
    handleAdd() {
      this.$router.push({
        name: 'orderCenter_profitSharing_index_add'
      });
    },
    getBankNamesFun(info, inAccountType) {
      return info.bankName;
    },
    getAccountNamesFun(num) {
      const enumObj = {
        1: '平安见证宝',
        2: '工银聚富通',
        3: '微信支付'
      };
      return enumObj[num];
    }

  }
};
</script>

<style lang="scss" scoped>
</style>
